import {animated, useTransition} from 'react-spring';

import animationDurations from '../../consts/animation/animationDurations';
import {twx} from '../../utils/tailwindUtils';

const HIDDEN = {opacity: 0};
const VISIBLE = {opacity: 1};
const GRID_AREA = {gridArea: '1 / 1'};

// mounts only the active layer (plus the outgoing one for the duration of its own fade-out),
// instead of keeping every possible layer sitting in the DOM forever.
// isSizedToActiveLayer takes the outgoing layer out of flow, so the container follows the arriving
// layer instead of the largest one - what a surrounding <AnimatedHeight> has to measure
export const CrossFade = ({
    activeKey,
    layers,
    className,
    layerClassName,
    hidden = HIDDEN,
    visible = VISIBLE,
    isSizedToActiveLayer = false,
}) => {
    const transitions = useTransition(activeKey, {
        from: hidden,
        // a first mount is not a change of layer: without this the layers of a freshly mounted
        // CrossFade fade in on top of whatever is already fading their container in
        initial: visible,
        enter: visible,
        leave: hidden,
        config: {duration: animationDurations.STATE_CHANGE_MS},
    });

    return (
        <span className={twx(isSizedToActiveLayer ? 'relative block' : 'grid', className)}>
            {transitions((style, key) => (
                <animated.span
                    style={isSizedToActiveLayer ? style : {...style, ...GRID_AREA}}
                    className={twx(
                        'block',
                        layerClassName,
                        // pinned, not stretched: it keeps its own layout while the container clips it
                        isSizedToActiveLayer && key !== activeKey && 'absolute inset-x-0 top-0'
                    )}
                >
                    {layers[key]}
                </animated.span>
            ))}
        </span>
    );
};
